import React from "react";
import styles from "./Modal.module.css";

const Modal = ({ message, onClose, children, type = "message" }) => {
  if (type === "message" && !message && !children) return null; // ✅ children이 있으면 모달을 렌더링

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.closeButton} onClick={onClose}>
          ✖
        </div>

        {type === "message" && message ? (
          <p className={styles.modalMessage}>{message}</p>
        ) : (
          children // 관리자 모달 등 다른 콘텐츠가 들어갈 경우 children 렌더링
        )}
      </div>
    </div>
  );
};

export default Modal;
